export const LINKS = {
    CLIENTS: '/clients',
    CAREERS: '/careers',
    SERVICES: '/services',
    EXPERTS: '/experts',
    ABOUT: '/about',
    TYPE_FORM_EXPERTS: 'https://liahnson-remember.com/expert/join?info=7dc405c6d4b9351c7c59b3e1f2f305259231c1b745d8fbe6e9e244eff778078d31dd22110fda1792000e86323bc56e6f49ba67',
    TYPE_FORM_CLIENTS: 'https://liahnson-remember.com/client/project/detail'
  } as const;
  
  export type Links = (typeof LINKS)[keyof typeof LINKS];
  